import type { EntityConfiguration } from '@technocom/data/core';
import { DictionaryRef } from '@app/shared/models/dictionaries/dictionary-ref';

/**
 * Гражданство
 */
export class Citizenship extends DictionaryRef {
  static readonly options: EntityConfiguration = DictionaryRef.extendOptions({
    namespace: 'cs',
    title: 'Гражданство',
    serverUrl: '/dictionary/citizenship',
  });
}
